import React from 'react';
import { connect } from 'react-redux';
import './style.scss';
import * as PopupActions from './actions';
import Tracker from '../../../genesys/tracker';
import View from '../../views/';
import { VIEW_MODES } from '../../views/types';

class PopupLayer extends React.Component {
    componentDidMount() {
        Tracker.sendEvent('popupOpened');
    }

    componentWillUnmount() {
        Tracker.sendEvent('popupClosed');
    }

    render() {
        const { popup } = this.props;

        if (!popup.currentConfig) {
            return null;
        }

        const classes = `popup-layer ${
            popup.currentConfig.theme ? popup.currentConfig.theme : 'opl-sg'
        } ${popup.currentView ? 'v-' + popup.currentView.toLowerCase() : ''}`;

        return (
            <div id="popup" className={classes}>
                <View
                    view={popup.currentView}
                    mode={VIEW_MODES.POPUP}
                    viewConfig={popup.currentConfig}
                    layerConfig={popup}
                    events={{ close: PopupActions.onClose }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        main: state.main,
        popup: state.popup
    };
};

export default connect(mapStateToProps)(PopupLayer);
